import { createFileRoute } from '@tanstack/react-router';
import { TemplateEditorScreen } from '../../../features/templates/template-editor-screen';

export const Route = createFileRoute('/_authenticated/template-uri/$templateId')({
  component: TemplateEditorRoute,
});

function TemplateEditorRoute() {
  const { templateId } = Route.useParams();

  return <TemplateEditorScreen templateId={templateId} />;
}
